import { useRestartNotification } from './use-restart-notification';

export function RestartNotificationProvider() {
    useRestartNotification();
    return <></>;
}
